var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlayMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99996 17.3337C4.39968 17.3286 0.671678 13.6006 0.666626 9.00034V8.83367C0.758236 4.25412 4.52878 0.606971 9.10885 0.667741C13.6889 0.728511 17.3614 4.47441 17.3314 9.05479C17.3015 13.6352 13.5804 17.3328 8.99996 17.3337ZM7.33329 5.25034V12.7503L12.3333 9.00034L7.33329 5.25034Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayMedia);
export default __webpack_public_path__ + "static/media/playMedia.e1a50f666f1b7faee85ba539270e4e46.svg";
export { ForwardRef as ReactComponent };